import { Result } from './model';
export var asPartialObject = function (schema) {
    return function (value, path) {
        if (typeof value !== 'object' || value === null) {
            return Result.error([{ path: path, expected: 'object' }]);
        }
        var results = {};
        var errors = [];
        for (var key in schema) {
            if (Object.hasOwnProperty.call(schema, key)) {
                if (!Object.hasOwnProperty.call(value, key)) {
                    continue;
                }
                var result = schema[key](value[key], path + "." + key);
                if (Result.isOk(result)) {
                    results[key] = result.ok;
                }
                else {
                    errors.push.apply(errors, result.error);
                }
            }
        }
        return errors.length > 0
            ? Result.error(errors)
            : Result.ok(results);
    };
};
